import { Box, Typography } from '@mui/material';
import { ThemeToggle } from '../../../../../components/ThemeToggle/ThemeToggle';
import { useStudioAuthenticatedContext } from '../../../../../context/StudioContext';
import * as styles from './HeaderSection.styles';

export const HeaderSection = () => {
  const { currentUser } = useStudioAuthenticatedContext();

  return (
    <Box component="header" sx={styles.header}>
      <Box sx={styles.headerContent}>
        <Box>
          <Typography variant="h4" color="text.primary">
            Welcome, {currentUser!.firstName}
          </Typography>
        </Box>

        <Box sx={styles.themeToggleContainer}>
          <ThemeToggle />
        </Box>
      </Box>
    </Box>
  );
};
